import { INITIAL_STATE, setTeams, addTeam, deleteTeam } from '../core'
import {
    RECEIVE_TEAMS,
    RECEIVE_TEAM,
    REMOVE_TEAM,
} from '../action_creators'

function teams(state=INITIAL_STATE.teams, action) {
    switch (action.type) {
        case RECEIVE_TEAMS:
            return setTeams(state, action.teams)
        case RECEIVE_TEAM:
            return addTeam(state, action.team)
        case REMOVE_TEAM:
            return deleteTeam(state, action.teamId)
        default:
            return state
    }
}

export default teams



// WEBPACK FOOTER //
// ./src/redux/reducers/teams_reducer.js